import React from 'react';
import './GoldRatesDisplay.css';

function GoldRatesDisplay({ goldRates, loading, error, onRetry }) {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <div className="loading-text">Loading Gold Rates...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-message">{error}</div>
        <button className="retry-button" onClick={onRetry}>
          Retry
        </button>
      </div>
    );
  }

  // Use provided rates or show empty state
  const rates = goldRates || [];

  if (!rates || rates.length === 0) {
    return (
      <div className="container">
        <div className="no-rates">
          <p>No gold rates available at the moment</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="rates-grid">
        {rates.map((rate, index) => (
          <div key={index} className="rate-card">            
            <div className="card-content">
              <div className="currency">AED</div>
              <div className="price">{rate.price}</div>
              <div className="karat">{rate.karat}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GoldRatesDisplay;